import DefaultMarketingPage from 'pages/default-marketing';

// This file will handle all of the new marketing page routes
// outlined here: https://spothero.atlassian.net/l/c/11D9VufX

const marketingRoutes = [
    {
        path: '/about/:slug?',
        component: DefaultMarketingPage,
        exact: true,
    },
    {
        path: '/faq/:slug?',
        component: DefaultMarketingPage,
        exact: true,
    },
    {
        path: '/parking/:slug?',
        component: DefaultMarketingPage,
        exact: true,
    },
    {
        // Prismic Preview Pages
        path: '/prismic-preview/:slug?',
        component: DefaultMarketingPage,
        exact: true,
    },
    {
        path: '/sell-parking/:slug?',
        component: DefaultMarketingPage,
        exact: true,
    },
    {
        path: '/get-spothero-app',
        component: DefaultMarketingPage,
        exact: true,
    },
];

export default marketingRoutes;
